(function(Overview) {
    'use strict';

    Overview.fetchURL = false;
    Overview.section = false;
    Overview.limit = false;
    Overview.container = false;
    Overview.loader = false;
    Overview.searchFilters = false;

    Overview.cardTemplate = false;
    Overview.subdivisionTemplate = false;

    Overview.data = [];

    Overview.filters = {
        'categories': [],
        'offset': 0
    };

    Overview.initSearch = function() {
        // ensure everything we need can be found
        Overview.container = $('.js-overview-container');
        Overview.loader = $('.js-overview-loader');

        if (Overview.container.length === 0) {
            return; // we are not on an updates page
        }

        Overview.searchFilters = $('.js-filter-container');
        Overview.section = Overview.container.data('section');

        Overview.fetchURL = Overview.container.data('fetch-url');
        if (typeof Overview.fetchURL === 'undefined' || Overview.fetchURL === '') {
            throw 'search fetch url not found';
        }

        Overview.limit = Overview.container.data('limit');
        if (typeof Overview.limit === 'undefined' || Overview.limit === '') {
            throw 'search limit not found';
        }

        Overview.cardTemplate = $('.js-overview-card-template');
        if (Overview.cardTemplate.length === 0) {
            throw 'search missing update card template';
        }

        Overview.subdivisionTemplate = $('.js-overview-subdivsion-template');
        if (Overview.section == 'partners' && Overview.subdivisionTemplate.length === 0) {
            throw 'search missing subdisvion template';
        }

        Overview.filterCategory = $('.js-result-filter-category');
        Overview.filterCategory.on('change', Overview.doFilterPartners);

        Overview.filterCountry = $('.js-result-filter-country');
        Overview.filterCountry.on('change', Overview.doSearch);

        Overview.initUi();
        Overview.doSearch(true);
    };

    Overview.showMoreButton = function() {
        var loadMore = $('.js-load-more-overview');
        loadMore.removeClass('is-hidden');
    };

    Overview.hideMoreButton = function() {
        var loadMore = $('.js-load-more-overview');
        loadMore.addClass('is-hidden');
    };

    Overview.doSearch = function(clearUpdates) {
        Overview.setFilters(clearUpdates);

        $.post(Overview.fetchURL, Overview.filters, Overview.generate);
    };

    Overview.generate = function(data) {
        Overview.data = data;
        var foundUpdates = data.items.length;

        Overview.filters.offset = parseInt(Overview.filters.offset) + parseInt(foundUpdates);

        if (Overview.section == 'partners' && Overview.filterCategory) {
            Overview.filterCategory.find('option').not(':first').remove();
            $.each(Overview.data.categories, function(key, category) {
                Overview.filterCategory.append(
                    $('<option/>', {
                        value: key,
                        text: category.name
                    })
                );
            });
        }

        Overview.doFilter(foundUpdates);
    };

    Overview.doFilterPartners = function(foundUpdates) {
        Overview.container.html('');
        Overview.doFilter(foundUpdates);
    };

    Overview.doFilter = function(foundUpdates) {
        var programHTML = '';

        Overview.loader.removeClass('is-hidden');

        Overview.setFilters(false);

        if (Overview.data.items.length === 0) {
            $('.js-overview-empty').removeClass('is-hidden');
            Overview.loader.addClass('is-hidden');
            return;
        }

        if (Overview.section == 'partners') {
            $.each(Overview.data.items, function(key, activity) {
                var partnerHtml = '',
                    category = false;

                $.each(activity, function(activityKey, program) {
                    partnerHtml += Overview.getCardHTML(program);
                    category = program.category.term_id;
                });

                if (category && Overview.data.categories[category] && Overview.categorySelected(category)) {
                    programHTML += Overview.getSubdivisionHtml(Overview.data.categories[category], partnerHtml);
                }
            });

        } else {
            $.each(Overview.data.items, function(key, program) {
                programHTML += Overview.getCardHTML(program);
            });
        }

        Overview.loader.addClass('is-hidden');
        Overview.container.append(programHTML);

        // did we get less updates than our limit of is there no limit?
        if (parseInt(foundUpdates) < parseInt(Overview.limit) || Overview.limit === false) {
            Overview.hideMoreButton();
        } else {
            Overview.showMoreButton();
        }
    };

    Overview.categorySelected = function(category) {
        if (Overview.filters.categories.length == 0 || Overview.filters.categories.indexOf(category + '') >= 0) {
            return true;
        } else {
            return false;
        }
    };

    Overview.getCardHTML = function(update) {
        var cardTemplate = Overview.cardTemplate.clone();
        var cardTemplateImage = cardTemplate.find('.js-overview-hero-image');

        if (update.image) {
            cardTemplateImage.css('background-image', 'url(' + update.image.full + ')');
            cardTemplateImage.removeClass('u-display--none');
        }

        cardTemplate.find('.js-overview-permalink').attr('href', update.permalink);

        if (update.url != '' && update.url != '#') {
            cardTemplate.find('.js-overview-url').attr('href', update.url);
            cardTemplate.find('.js-overview-url').attr('target', '_blank');
        } else {
            cardTemplate.find('.js-overview-url').attr('href', update.permalink);
        }

        var image = cardTemplate.find('.js-overview-image');
        if (image && update.image) {
            image.attr('src', update.image.full);
        }

        var title = cardTemplate.find('.js-overview-title');
        if (title && update.title) {
            title.html(update.title);
        }

        var subtitle = cardTemplate.find('.js-overview-subtitle');
        if (subtitle.length > 0 && update.country) {
            subtitle.html(Overview.countryList(update.country, true));
        }

        return cardTemplate.html();
    };

    Overview.setFilters = function(clearUpdates) {
        var filterValue,
            categoryFilter = Overview.searchFilters.find('.js-result-filter-category');

        if (clearUpdates) {
            Overview.filters.offset = 0;
            Overview.container.html('');
        }

        Overview.filters.categories = [];

        $.each(categoryFilter, function() {
            filterValue = $(this).val();
            if (filterValue) {
                Overview.filters.categories.push(filterValue);
            }
        });

        if (Overview.filterCountry.val()) {
            Overview.filters.categories.push(Overview.filterCountry.val());
        }
    };

    Overview.getSubdivisionHtml = function(category, partnersHtml) {
        var template = Overview.subdivisionTemplate.clone();

        var title = template.find('.js-overview-subdivsion-title');
        if (title && category) {
            title.html(category.name);
        }

        var partners = template.find('.js-overview-subdivsion-pack');
        if (partners && partnersHtml) {
            partners.html(partnersHtml);
        }

        return template.html();
    };

    Overview.initUi = function() {
        var $loadMore = $('.js-load-more-overview');

        $loadMore.on('click', function(e) {
            e.preventDefault();
            Overview.doSearch(false);
        });
    };

    Overview.countryList = function(countries, _interactive) {
        var interactive = _interactive || false;
        var list = [];

        countries.forEach(function(element) {
            var country = element.title;

            if (interactive) {
                country = '<a class="js-result-filter-country-link" href="#" data-id="' + element.id + '">' + element.title + '</a>';
            }

            list.push(country);
        });

        return list.join(', ');
    };

    Overview.countryLink = function(event) {
        event.preventDefault();

        var id = $(this).data('id');
        var $option = $('.js-result-filter-country').find('option[value="' + id + '"]');

        $option.prop('selected', true);

        Overview.doSearch(true);
    };

})(window.Way2web.Overview = window.Way2web.Overview || {});
